/** 标签栏历史页签菜单图标。 */
export function MenuSvgIcon() {
    return (
        <svg
            className="tabs-control-icon tabs-menu-svg-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <path fill="currentColor" d="M18 7H6V5h12v2Zm0 5H6v-2h12v2Zm0 5H6v-2h12v2Z" />
        </svg>
    );
}

export default MenuSvgIcon;
